<template>
  <!-- 
    @Author shirleywanghui@didichuxing.com
    @Date 2022-04-26
    @Description cgc推荐页改版 - 分享区域 - button复制code码
  -->
    <div class="xtc-share-button-code">
      <span class="code">{{recommendCode}}</span>
      <span
        v-if="clipboard"
        class="copy-btn"
        :data-clipboard-text="copyContent"
        @click="$emit('copyHandle')"
      >
        <div class="xtc-share-button-code-img">{{$t('FoodC_CGC_Copy_MtAU')}}</div>
      </span>
    </div>
</template>
<script>
export default {
  props: {
    // 兑换码：FOOD-J82RPF
    recommendCode: {
      type: String,
      default: ''
    },
    // 要复制的内容，比如：Hola, tu amigo te ha enviado MX$130.00 MXN de descuento para tu primer pedido. Obténlo aquí:
    copyContent: {
      type: String,
      default: ''
    },
    clipboard: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {}
  }
}
</script>
<style scoped lang="stylus">
.xtc-share-button-code {
  margin-top: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 638px;
  height: 88px;
  background: #F5F5F7;
  border-radius: 12px;
  .code {
    // width: 356px;
    height: 48px;
    // font-family: DiDiSansPro-Bold;
    font-family: 'Aspira Demi';
    font-size: 48px;
    color: #000000;
    letter-spacing: 0px;
    text-align: center;
    line-height: 48px;
    font-weight: 700;
  }
  .copy-btn {
    position: absolute;
    right: 28px;
    margin-left: 32px;
    line-height: 48px;
  }
}
// [data-theme="didi"] .xtc-share-button-code .xtc-share-button-code-img {
//   width: 81px;
//   height: 32px;
//   background url('https://img0.didiglobal.com/static/soda_public/do1_PPJ1EUwLNJpYj7y8YUjL') center/81px no-repeat
// }
// [data-theme="99"] xtc-share-button-code .xtc-share-button-code-img {
//   width: 81px;
//   height: 32px;
//   background url('../../../../assets/images/cgc/99/share_button_copy.png') center/81px no-repeat
// }
.xtc-share-button-code-img {
  width: 81px;
  height: 32px;
  border: 1px solid #FF7A45;
  border-radius: 8px;
  font-size: 24px;
  color: #FF7A45;
  justify-content: center;
  align-items: center;
  display: flex;
  font-family: Aspira Medium;
  font-weight: 500;
}
</style>